module.exports = __webpack_public_path__ + "img/barrier-old.6b1b4411.jpg";